import { camelCase } from 'change-case'
import BIKE_ATTRIBUTES from '@/js/helper/bike-attributes.js'

export const includedCustomBasketAttributes = [
  camelCase(BIKE_ATTRIBUTES.TYPE.PRODUCT_ORDER_PAYMENT_TARGET),
  camelCase(BIKE_ATTRIBUTES.TYPE.PRODUCT_ORDER_DELIVERY),
  camelCase(BIKE_ATTRIBUTES.TYPE.PRODUCT_ORDER_BIKE_BRAND),
  camelCase(BIKE_ATTRIBUTES.TYPE.PRODUCT_ORDER_BRAND),
]
